// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"A1","editButton":"A2","formClass":"A3","rowClass":"A4","columnClass":"A5","inputClass":"A6","email":"A7","mobile":"A8","cancelButton":"A9","submitButton":"A-"};